import React from "react";
import {
  Container,
  Title,
  Text,
  Card,
  Stack,
  Button,
  Center,
  Grid,
  ThemeIcon,
  Box
} from '@mantine/core';
import {
  IconFileImport,
  IconDatabase,
  IconFileText,
  IconTools,
  IconTopologyStar,
  IconDownload,
  IconPhone,
  IconCloudDownload
} from '@tabler/icons-react';

const Options = ({ options, onSelect, onTemplateDownload }) => {
  // Icon mapping for different tools
  const toolIcons = {
    ddw: IconFileImport,
    sqlProcessor: IconDatabase,
    asBuilt: IconFileText,
    tools: IconTools,
    flowCreator: IconTopologyStar,
    wxccOpsCenter: IconPhone,
    connectExporter: IconCloudDownload
  };

  return (
    <Box
      style={{
        minHeight: '80vh',
        background: 'linear-gradient(135deg, #1976d2 0%, #e3f2fd 100%)',
        padding: '40px 20px',
        borderRadius: '16px'
      }}
    >
      <Container size="lg">
        <Center>
          <Stack align="center" gap="xl" style={{ maxWidth: '1000px' }}>
            {/* Header Section */}
            <Stack align="center" gap="md">
              <Title
                order={1}
                size="2.5rem"
                fw={700}
                style={{ color: 'white', textAlign: 'center' }}
              >
                Cisco WxCC Tools
              </Title>
              <Text
                size="xl"
                style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center' }}
              >
                Choose the DDD Import tool you would like to use
              </Text>
            </Stack>

            {/* Tools Selection Grid */}
            <Grid gutter="xl" style={{ width: '100%', maxWidth: '1200px' }}>
              {Object.keys(options).map((key) => {
                const option = options[key];
                const IconComponent = toolIcons[key] || IconTools;

                return (
                  <Grid.Col key={key} span={{ base: 12, sm: 6, md: 4 }}>
                    <Card
                      shadow="xl"
                      padding="xl"
                      radius="md"
                      style={{
                        background: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        height: '320px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-8px)';
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                      }}
                      onClick={() => onSelect(key)}
                    >
                      <Stack align="center" gap="md" style={{ flex: 1 }}>
                        <ThemeIcon
                          size={80}
                          radius="md"
                          color="blue"
                          variant="light"
                        >
                          <IconComponent size={48} />
                        </ThemeIcon>

                        <Title order={3} size="1.3rem" fw={600} align="center">
                          {option.name}
                        </Title>

                        <Text
                          size="sm"
                          color="dimmed"
                          align="center"
                          style={{ lineHeight: 1.5, flex: 1 }}
                        >
                          {option.description}
                        </Text>

                        <Stack gap="xs" style={{ width: '100%' }}>
                          <Button
                            color="blue"
                            size="md"
                            radius="md"
                            fullWidth
                            onClick={(e) => {
                              e.stopPropagation();
                              onSelect(key);
                            }}
                            disabled={option.disabled}
                            style={{ fontWeight: 600 }}
                          >
                            Select {option.name}
                          </Button>

                          {/* Template Download Button for DDW */}
                          {key === 'ddw' && option.templatePath && (
                            <Button
                              variant="light"
                              color="blue"
                              size="sm"
                              radius="md"
                              fullWidth
                              leftSection={<IconDownload size={16} />}
                              onClick={(e) => {
                                e.stopPropagation();
                                onTemplateDownload(option.templatePath, option.templateFileName);
                              }}
                            >
                              Template Download
                            </Button>
                          )}
                        </Stack>
                      </Stack>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>

            {/* Footer Info */}
            <Stack align="center" gap="xs" style={{ marginTop: '40px' }}>
              <Text
                size="sm"
                style={{ color: 'rgba(255, 255, 255, 0.7)', textAlign: 'center' }}
              >
                Professional Cisco WxCC configuration and automation tools
              </Text>
              <Text
                size="xs"
                style={{ color: 'rgba(255, 255, 255, 0.5)', textAlign: 'center' }}
              >
                Presidio Networked Solutions, Inc.
              </Text>
            </Stack>
          </Stack>
        </Center>
      </Container>
    </Box>
  );
};

export default Options;